<template >
  <div >
    <div>
      <span >
        <coingecko-coin-price-marquee-widget
        coin-ids="bitcoin,ethereum,eos,ripple,litecoin"
        currency="usd"
        background-color="#eeeeee"
        locale="fr"
      ></coingecko-coin-price-marquee-widget>
      </span>

      <vue-particles
        color="#dedede"
        :particleOpacity="1"
        :particlesNumber="10"
        shapeType="circle"
        :particleSize="4"
        linesColor="#dedede"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="5"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="repulse"
        class="particles-js"
      ></vue-particles>
    </div>

    <div id="part1">
      <br />
      <v-flex text-xs-center xs12>
        <v-layout row wrap justify-space-around>
          <v-flex xs12 md7>
            <h1 class="main_title white--text">
              meilleure plateforme d'echange
              <br />
            </h1>
            <h2 id="typed" class="typed white--text"></h2>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <div class="" style="margin-left: 25% !important;">
              <vs-button
              color="#1d4468"
              class="btn_grand"
              gradient-color-secondary="#235d93"
              width="200"
              @click="$router.push('/register')"
              type="gradient"
            >creer un compte</vs-button>
            </div>
            
            <br />
            <br />
            <br />
            <br />
            <v-layout row wrap>
              <v-flex xs4 v-for="(item, id) in currencies" :key="id">
                <img :src="item.src" width="60" :alt="item.name" style="opacity:0.2" />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md5 class="mt-5 mb-5" align-center hidden-sm-and-down>
            <div id="imag" class="mt-5 ml-1">
              <object type="image/svg+xml" data="/img/btc_p2p.svg" width="500" height="400"></object>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </div>

    <div>
      <div class=" container-fluid pt-5" style="text-align:center;">
        <h1 class="simple display-2">simple et rapide</h1>
        <div class="start_container">
          
          <div class="start_card my-5">
            <div class="number">
              <img src="/img/one.svg" alt="">
            </div>
            <div class="pt-5 pb-2" style="background-color:#154DFF; border-radius:20px 20px 0 0;">
              <h2 class="white--text">S'inscrire</h2>
            </div>
            <div class="card_body mt-3 ml-2"  style="text-align:left;">
              <div class="mb-3"><v-icon class="mr-2">person</v-icon><h2  style="display:inline-block;">Entrez vos informations</h2></div>
              <img src="/img/email-valid.png" class="mr-2" width="26" alt=""><h2  style="display:inline-block;">Validez votre email</h2>
            </div>
          </div>

          <div class="start_card my-5">
            <div class="number">
              <img src="/img/two.svg" alt="">
            </div>
            <div class="pt-5 pb-2" style="background-color:#154DFF; border-radius:20px 20px 0 0;">
              <h2 class="white--text">Faire un depot</h2>
            </div>
            <div class="card_body mt-3 ml-2"  style="text-align:left;">
              <div class="mb-3"><v-icon class="mr-2">monetization_on</v-icon><h2  style="display:inline-block;">Entrez le montant</h2></div>
              <img src="/img/transfer.png" class="mr-2" width="26" alt=""><h2  style="display:inline-block;">Choisir le moyen de depot</h2>
            </div>
          </div>

         <div class="start_card my-5">
            <div class="number">
              <img src="/img/three.svg" alt="">
            </div>
            <div class="pt-5 pb-2" style="background-color:#154DFF; border-radius:20px 20px 0 0;">
              <h2 class="white--text">Echanger</h2>
            </div>
            <div class="card_body mt-3 ml-2"  style="text-align:left;">
              <div class="mb-3"><v-icon class="mr-2">swap_horizontal_circle</v-icon><h2  style="display:inline-block;">Echanger instantanément</h2></div>
              <img src="/img/exchange.png" class="mr-2" width="26" alt=""><h2  style="display:inline-block;">Retirer dans la seconde</h2>
            </div>
          </div> 
        </div>


      </div>
    </div>

    <div style="text-align:center;" class="mt-4 mb-5">
      <h1 class="simple display-2">pas besoin d'être expert</h1>
      <h5 class="title">suivez juste ces videos et vous êtes prêts pour votre première transaction</h5>
    </div>
<div class="iframe mb-5">
  <div class="iframe-container mt-5" style="width:400px;">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/epmxjtjsaXQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    <div class="iframe-container  mt-5">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/OwPUWmHT6CU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
</div>

<div style="text-align:center;" class="mt-5 py-5">
      <h1 class="simple display-2">meilleur programme de parrainage</h1>
      <h5 class="title">HIROPAY vous fait gagner jusqu'à 10% de la commission générée a chaque trade de vos filleuls</h5>
</div>

<div style="height: 100px;"></div>

  
    <subFooter />
  </div>
</template>

<script >
const subFooter = () => import("../components/subFooter");
import Typewriter from "typewriter-effect/dist/core";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    subFooter
  },
  data() {
    return {
      gecko: "",
      pwa:false,
      pr: false,
      videoId: "M9AwPz0a0q0",
      currencies: [
        { id: 1, name: "bitcoin", src: "/img/bitcoin.svg" },
        { id: 2, name: "perfectmoney", src: "/img/perfectmoney.png" },
        { id: 3, name: "ethereum", src: "/img/ethereum.svg" }
      ],
    };
  },

  computed: {
    
    recent_btc() {
      return this.btccfa[0].price.toFixed(0);
    },
   
    prec_btc() {
      return this.btccfa[1].price.toFixed(0);
    },
    recent_pm() {
      return this.pmcfa[0].price.toFixed(0);
    },
    prec_pm() {
      return this.pmcfa[1].price.toFixed(0);
    },
     items(){
      let x=[
        // {id:1, recent:this.recent_btc, prec:this.prec_btc, pair:'BTC/CFA',src:'/img/bitcoin.svg', href:'/dashboard'},
        {id:1, recent:this.recent_pm, prec:this.prec_pm, pair:'PM/CFA',src:'/img/perfectmoney.png', href:'/dashboard/pm-cfa'},
      ]
      return x;
    },
    ...mapGetters({
      btccfa: "exchanged/btccfa_exchanged",
      pmcfa: "exchanged/pmcfa_exchanged"
    })
  },
  beforeMount () {
    const standalone= ()=> (window.matchMedia('(display-mode: standalone)').matches);
    if (standalone()) {
      this.$router.push('/login')
    }
  },
  mounted() {
    let app = document.getElementById("typed");
    setTimeout(() => {
      this.pr = true;
    }, 1500);
    let typewriter = new Typewriter(app, {
      loop: true
    });
    typewriter
      .typeString(
        "<strong >TOGO</strong>  <img src='/img/togo.png' width='50' alt='togo'/>"
      )
      .pauseFor(2500)
      .deleteChars(6)
      .typeString(
        "<strong>BENIN</strong>  <img src='/img/benin.png' width='50' alt='benin'/>"
      )
      .pauseFor(2500)
      .deleteChars(7)
      .typeString(
        "<strong>COTE D'IVOIRE</strong>  <img src='/img/ivoire.png' width='50' alt='cote d'ivoire'/>"
      )
      .pauseFor(2500)
      .deleteChars(15)
      .typeString(
        "<strong>MALI</strong>  <img src='/img/mali.png' width='50' alt='mali'/>"
      )
      .pauseFor(2500)
      .deleteChars(6)
      .typeString(
        "<strong>NIGER</strong>  <img src='/img/niger.png' width='50' alt='mali'/>"
      )
      .pauseFor(2500)
      .deleteChars(7)
      .typeString(
        "<strong>BURKINA-FASO</strong>  <img src='/img/burkina faso.png' width='50' alt='mali'/>"
      )
      .pauseFor(2500)
      .deleteChars(14)
      .typeString(
        "<strong>SENEGAL</strong>  <img src='/img/senegal.png' width='50' alt='senegal'/>"
      )
      .pauseFor(2500)
      .deleteChars(7)
      .start();

    this.bind_pmcfa_exchanged();
    this.bind_btccfa_exchanged();
  },
  methods: {
    ...mapActions({
      bind_btccfa_exchanged: "exchanged/bind_btccfa_exchanged",
      bind_pmcfa_exchanged: "exchanged/bind_pmcfa_exchanged"
    })
  },
  metaInfo() {
    return {
      title: 'HIROPAY - Vente, achat et échange de cryptomonnaies en Afrique de l\'Ouest',
      meta: [
        { name: 'description', content: 'HIROPAY est une plateforme de vente, d\'achat et d\'échange de cryptomonnaies en Afrique de l\'Ouest. Achetez, vendez et échangez des cryptos de manière simple et sécurisée.' },
        { name: 'keywords', content: 'cryptomonnaie Afrique de l\'Ouest, acheter bitcoin en Afrique, échange crypto Togo, plateforme crypto Sénégal, acheter Ethereum Côte d\'Ivoire, cryptos populaires en Afrique de l\'Ouest, trading crypto Burkina Faso, investir dans la crypto en Afrique, Bitcoin Togo, Ethereum au Sénégal, crypto monnaie en Côte d\'Ivoire, cryptomonnaie légale en Afrique de l\'Ouest, acheter des cryptomonnaies avec CFA' },
        { name: 'author', content: 'HIROPAY' },
        { property: 'og:title', content: 'Achetez, vendez et échangez des cryptomonnaies sur HIROPAY' },
        { property: 'og:description', content: 'Rejoignez HIROPAY, la plateforme de cryptomonnaies leader en Afrique de l\'Ouest pour acheter, vendre et échanger des cryptomonnaies en toute sécurité.' },
        { property: 'og:image', content: 'URL_DE_VOTRE_IMAGE_OU_LOGO' },
        { property: 'og:url', content: 'https://hiropay.com' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'HIROPAY - Échangez des cryptomonnaies en Afrique de l\'Ouest' },
        { name: 'twitter:description', content: 'Découvrez HIROPAY, une plateforme de vente et d\'échange de cryptomonnaies sécurisée pour les utilisateurs en Afrique de l\'Ouest.' },
        { name: 'twitter:image', content: 'https://hiropay.com/img/logo.png' },
      ]
    };
  }
};
</script>
<style scoped>
body{
font-family: 'Teko', sans-serif !important;
}
img.imx {
  display: block;
  border: 1px solid #ddd;
  border-radius: 50%;
  margin-left: auto;
  margin-right: auto;
  max-width: 150px;
}
#part1 {
  background-image: url("/img/global.png");
  background-color: #003449;
}
h1.main_title{
  font-family: 'Teko', sans-serif !important;
  letter-spacing: 3px;
  font-size: 3em !important;
  text-transform: uppercase;
  font-weight: 800 !important;
}
.btn_grand {
  
  width: 250px;
  padding-top: 20px;
  padding-bottom: 20px;
}
h1.simple{
  font-family: 'Teko', sans-serif !important;
  font-size:24px;
  font-weight: bold;
	letter-spacing: 1.4px !important;
	text-transform:uppercase;
	text-decoration:none;
}
a.v-card {
  margin:auto;
}


a.v-card.v-card--hover {
  text-decoration: none;
}
div.con-vs-card.vscard.withHover {
  max-width: 300px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

div.start_container{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 100%;
  margin: auto;
  padding-top: 5vh;
  padding-left: 2vh;
}
div.start_card{
  font-family: 'Teko', sans-serif !important;
  letter-spacing: 1px;
  width: 250px;
  height: 250px;
  background-color:antiquewhite;
  border: 1px solid skyblue;
  border-radius: 20px;
}
div.number{
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin: -35px auto;
  padding-bottom: 10px;
  background-color: white;
  position: relative;
  z-index: 1;
}
div.start_card:hover{
  transform: scale(1.2, 1.2);
  transition: 0.5s;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* #part1 {
  height: 80vh;

  background-image: linear-gradient(to bottom right, #046C84, #046C84);
} */
h1.main_title {
  font-family: inherit;
  font-weight: 500;
  font-size: 3em;
}
h3.headline {
  font-family: "Roboto Mono", "Courier New", monospace !important ;
  font-weight: 200 !important;
  font-size: 22px !important;
  line-height: 40px !important;
  letter-spacing: -1px !important;
  word-spacing: -5px !important;
}
/* 5 */
#descrip.container {
  
}
div.iframe{
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
div.iframe-container{
  width:400px ;
}
.iframe-container iframe{
  width: 400px;
  height: 230px;
}
.iframe-container iframe:hover{
transform: scale(1.3, 1.3);
  transition: 0.5s;
}


.particles-js {
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 80vh;
}
</style>
